{
  "close": "Close",
  "notifications": "Notifications"
}
